import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const RiskBoxStyle = styled.div`
  /* Parent styles
  ------------------------------- */

  color: ${VARIABLES.COLORS.WHITE};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
  flex: 1;
  width: 100%;
  height: 100%;
  border-radius: 8px;

  &.red {
    background: #ce1f0f;
    border: 4px solid #ce1f0f;
    box-shadow: 0px 0px 8px #ce1f0f;
  }
  &.orange {
    background: #fc8601;
    border: 4px solid #fc8601;
    box-shadow: 0px 0px 8px #fc8601;
  }
  &.light-orange {
    background: #f5ab02;
    border: 4px solid #f5ab02;
    box-shadow: 0px 0px 8px #f5ab02;
  }
  &.light-green {
    background: #8ad000;
    border: 4px solid #8ad000;
    box-shadow: 0px 0px 8px #8ad000;
  }
  &.green {
    background: #16a651;
    border: 4px solid #16a651;
    box-shadow: 0px 0px 8px #16a651;
  }
  &.gray {
    background: #aaaaaa;
    border: 4px solid #aaaaaa;
    box-shadow: 0px 0px 8px #aaaaaa;
  }

  .score {
    font-weight: 600;
    font-size: 32px;
  }

  .title {
    font-size: 14px;
  }
  .tooltip {
    border-radius: 8px;
    font-size: 16px;
  }
  /* Child element styles
  ------------------------------- */
  /* Modifiers
  ------------------------------- */
  /* State
  ------------------------------- */
  /* Media queries
  ------------------------------- */
  /* Start max-width: '1439px'*/
  @media all and (max-width: ${VARIABLES.BREAKPOINTS.DESKTOP_SM_MAX}) {
    padding: 5px;

    .score {
      font-size: 20px;
    }

    .title {
      font-size: 12px;
    }
  }
`
